"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Actions = require("../../actions/Actions");

var BulkImportFromUrlPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BulkImportFromUrlPanel, _Component);

  function BulkImportFromUrlPanel() {
    (0, _classCallCheck2.default)(this, BulkImportFromUrlPanel);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BulkImportFromUrlPanel).apply(this, arguments));
  }

  (0, _createClass2.default)(BulkImportFromUrlPanel, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("span", null, "This is a placeholder panel");
    }
  }]);
  return BulkImportFromUrlPanel;
}(_react.Component);

BulkImportFromUrlPanel.propTypes = {};
BulkImportFromUrlPanel.defaultProps = {
  hasAcceptedImportCopyrightNotice: false
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onBack: function onBack() {
      dispatch((0, _Actions.goBack)());
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(BulkImportFromUrlPanel);

exports.default = _default;
module.exports = exports.default;